<template>
  <b-container>
    <!-- <img src="https://www.britehouse.co.za/_catalogs/masterpage/Britehouse/images/Britehouse_Web.gif">
    <h1 v-if="!user">{{ msg }}</h1>
    <h1 v-if="user">{{ msg }} {{ user.name }}</h1>
    <button @click="login" type="button" v-if="!user">Login</button>
    <div v-if="!user">You should be redirected to login automatically</div> -->
    <!-- <button @click="callAPI" type="button" v-if="user && user.name == 'Bjorn Bergmann (Britehouse)'">
      Call Graph's /me API
    </button> -->

      <b-navbar toggleable="md" type="dark" variant="info">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <b-form-checkbox id="autosave"
                  v-model="autoSave"
                  :plain=true>
            AutoSave
          </b-form-checkbox>
        <b-navbar-brand href="#">Britehouse</b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <b-nav-item @click="logout" v-if="user" href="#">Signout {{ user.name }}</b-nav-item>
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

    <b-card no-body v-if="!!user">
      <b-tabs card>
        <b-tab :title="`${team.text}`" v-for="(team, key) in teams" :key="key">

          
          <!-- {{ JSON.stringify(i) }} -->
          <keep-alive>
            <food 
              :team="team"
              :user="user"
              :auto-save=autoSave
            />
          </keep-alive>
          
          <!-- <div v-if="ratings[i.id]">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">

              <div v-for="rating in ratings[i.id]" :key="rating.text">

                <b-form-group id="rating.text">
                  <div class="my-3">
                    <b-btn variant="primary" v-b-popover.hover.top="`${rating.description}`">{{ rating.text }}</b-btn>
                  </div> 
                  <heart-rating 
                    :max-rating="rating.max" 
                    :show-rating=false 
                    inactive-color="#440522"
                    active-color="#cc1166"
                    :increment="1" 
                    v-model="rating.value">
                  </heart-rating>
                </b-form-group>
              </div>
              <b-button type="submit" variant="primary">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </b-form>
          </div> -->


        </b-tab>

        <!-- New Tab Button (Using tabs slot) -->
        <!-- <b-nav-item slot="tabs" @click.prevent="newTab" href="#">
          +
        </b-nav-item> -->

        <!-- Render this if no tabs -->
        <div slot="empty" class="text-center text-muted">
          There are currently no teams you need to score
         
          <!-- <br> Open a new tab using + button. -->
        </div>
      </b-tabs>
    </b-card>
  </b-container>
  


</template>

<script>
import AuthService from './services/auth.service';
import GraphService from './services/graph.service';
// import { HeartRating } from 'vue-rate-it';
import Food from './components/food.vue';

export default {
  mounted() {
    // console.log('HERE ----------------------------------------------------')
    // console.log(this);
    // console.log(this.$ls.get('britheouse-team-stored-data'));
    // console.log(this);
    // if (this.$ls.get('britheouse-team-stored-data') && this.$ls.get('britheouse-team-stored-user') === this.user.name) {
    //   this.ratings = JSON.parse(this.$ls.get('britheouse-team-stored-data'))
    // } else {
    //   var r = {}
    //   // console.log(this.teams);
    //   this.teams.forEach(team => {
    //     console.log(team.id)
    //     r[team.id] = Object.assign(this.defaultRating)
    //   });
    //   // this.$ls.set('britheouse-team-stored-user', this.user.name)
    //   this.$ls.set('britheouse-team-stored-saved', false)
    //   this.$ls.set('britheouse-team-stored-data', JSON.stringify(r))
    //   // console.log('HERE ----------------------------------------------------')
    //   // console.log(JSON.stringify(r));
    //   // console.log(JSON.stringify({ x: 5, y: 6 }))
    //   // console.log(r);
    //   this.ratings = r
    // }
  },
  data() {
    return {
      msg: '',
      selected: null,
      user: null,
      userInfo: null,
      apiCallFailed: false,
      loginFailed: false,
      autoSave: true,
      // defaultRating: {
      //   origionality: {
      //     value: 3,
      //     text: "origionality",
      //     description: "This is the description for being origional",
      //     max: 5
      //   },
      //   appearance: {
      //     value: 3,
      //     text: "appearance",
      //     description: "This is the description for being appearance",
      //     max: 5
      //   },
      //   texture: {
      //     value: 3,
      //     text: "texture",
      //     description: "This is the description for being texture",
      //     max: 5
      //   },
      //   aroma: {
      //     value: 3,
      //     text: "aroma",
      //     description: "This is the description for being aroma",
      //     max: 5
      //   },
      //   taste: {
      //     value: 3,
      //     text: "taste",
      //     description: "This is the description for being taste",
      //     max: 5
      //   }
      // },
      teams: [
        { id: 0, text: 'Blue Team', color: 'blue', tc: '#004d99', bc: '#7FDBFF', bdc: '#001f3f' },
        { id: 1, text: 'Purple Team', color: 'purple', tc: '#260339', bc: '#f2ccff', bdc: '#3D1255' },
        { id: 2, text: 'Orange Team', color: 'orange', tc: '#ff6600', bc: '#ffe0cc', bdc: '#4d1f00' },
        { id: 3, text: 'Green Team', color: 'green', tc: '#003300', bc: '#e6ffe6', bdc: '#001a00' },
        { id: 4, text: 'Yellow Team', color: 'yellow', tc: '#333300', bc: '#ffff99', bdc: '#333300' },
        { id: 5, text: 'Red Team', color: 'red', tc: '#ff0000', bc: '#ffe6e6', bdc: '#660000' }
      ],
      show: true
    }
  },
  created() {
    

    this.authService = new AuthService();
    this.graphService = new GraphService();
    this.user = this.authService.getUserInformation();
    // if (this.user)
    //   console.log(this.user);

  },
  methods: {
    callAPI() {
      this.apiCallFailed = false;
      this.authService.getToken().then(
        token => {
          this.graphService.getUserInfo(token).then(
            data => {
              // console.log(data);
              this.userInfo = data;
            },
            error => {
              console.error(error);
              this.apiCallFailed = true;
            }
          );
        },
        error => {
          console.error(error);
          this.apiCallFailed = true;
        }
      );
    },
    
   

    logout() {
      this.authService.logout();
    },

    login() {
      this.loginFailed = false;
      this.authService.login();
    }
  },
  components:{
    Food
  }

}
</script>
<style scoped>
.red {
  color:red
}
</style>



// WEBPACK FOOTER //
// src/App.vue